import { VendorMetadata } from "../type";

import { Vendor } from "./data";

export const Box: VendorMetadata = Object.freeze({
  id: Vendor.box,
  name: "Box",
});
